import React from 'react'
import Reveal from './Reveal'
import SectionHead from './SectionHead'
import { usePlaces, useDistance } from '../i18n/hooks'
import { useI18n } from '../i18n/LanguageContext'

const distanceIds = ['tatul', 'momchilgrad', 'kardzhali', 'perperikon', 'kardzhali-reservoir']

function Overview() {
  const { t } = useI18n()
  const { getPlace } = usePlaces()
  const distanceTo = distanceIds.map(getPlace)
  const distance = useDistance()

  return (
    <section className="section" id="overview" aria-labelledby="overview-title">
      <div className="container">
        <SectionHead id="overview-title" kicker={t.overview.kicker} title={t.overview.title} />
        <div className="overview-grid">
          <Reveal className="prose">
            <p className="prose-lead">{t.overview.paragraphs[0]}</p>
            {t.overview.paragraphs.slice(1).map((text) => (
              <p key={text}>{text}</p>
            ))}
            <p className="note">{t.overview.note}</p>
          </Reveal>
          <Reveal className="overview-side" delay={120}>
            <div className="panel">
              <h3>{t.overview.panelTitle}</h3>
              <p className="panel-note">{t.overview.panelNote}</p>
              <ul className="distance-list">
                {distanceTo.map((place) => (
                  <li key={place.id}>
                    <span>{place.shortName ?? place.name}</span>
                    <strong>{distance(place)}</strong>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  )
}

export default Overview
